<div class="asc-day-until-stock-out-formula">
  <math xmlns="http://www.w3.org/1998/Math/MathML">
    <mrow>
      <mi>
        <strong>Days Until Stockout</strong>
      </mi>
      <mo>=</mo>
      <mfrac>
        <mrow>
          <mi>Inventory</mi>
        </mrow>
        <mrow>
          <mi>Velocity</mi>
        </mrow>
      </mfrac>
      <ng-container *ngIf="!isWrap;else wrap">
        <mo>=</mo>
        <mfrac>
          <mrow>
            <mn>{{ inventory }}</mn>
          </mrow>
          <mrow>
            <mn>{{ velocity }}</mn>
          </mrow>
        </mfrac>
        <mo>=</mo>
        <mn>
          <strong *ngIf="inventory >= 0 && velocity > 0">{{ daysUntilStockOut }}</strong>
          <strong *ngIf="inventory > 0 && velocity === 0">&#8734;</strong>
        </mn>
      </ng-container>
    </mrow>
  </math>
</div>
<ng-template #wrap>
  <mrow>
    <mi>
      <strong>Stockout Days</strong>
    </mi>
    <mo>=</mo>
    <mfrac>
      <mrow>
        <mn>{{ inventory }}</mn>
      </mrow>
      <mrow>
        <mn>{{ velocity }}</mn>
      </mrow>
    </mfrac>
    <mo>=</mo>
    <mn>
      <strong>{{ daysUntilStockOut }}</strong>
    </mn>
  </mrow>
</ng-template>
